<footer class="footer-light font-small fixed-bottom bg-custom">
    <div class="footer-copyright text-center py-2">
        Copyright © - Designed and Created by: <em><strong>Carlos Mur</strong></em>
    </div>
</footer>